import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var UFOLogger = /*#__PURE__*/function () {
  function UFOLogger() {
    _classCallCheck(this, UFOLogger);
    _defineProperty(this, "enabled", false);
  }
  return _createClass(UFOLogger, [{
    key: "log",
    value: function log() {
      var _console;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      // eslint-disable-next-line no-console
      this.enabled && (_console = console).log.apply(_console, [UFOLogger.UFOprefix].concat(args));
    }
  }, {
    key: "warn",
    value: function warn() {
      var _console2;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      // eslint-disable-next-line no-console
      this.enabled && (_console2 = console).warn.apply(_console2, [UFOLogger.UFOprefix].concat(args));
    }
  }, {
    key: "enable",
    value: function enable() {
      this.enabled = true;
    }
  }, {
    key: "disable",
    value: function disable() {
      this.enabled = false;
    }
  }]);
}();
_defineProperty(UFOLogger, "UFOprefix", '[ufo🛸]');
export var ufologger = new UFOLogger();
export var ufolog = function ufolog() {
  ufologger.log.apply(ufologger, arguments);
};
export var ufowarn = function ufowarn() {
  ufologger.warn.apply(ufologger, arguments);
};